<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Tìm kiếm">
          <div slot="custombtn">
            <button id="popover-config-search" class="btn btn-box-tool">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </button>
            <b-popover :show.sync="showConfigSearch" target="popover-config-search" title="Cấu hình hiển thị"
                       triggers="hover">
              <b-table :items="configSearchItems" responsive :fields="configFields">
                <template v-slot:cell(key)="data">
                  <b-form-checkbox v-model="data.item.show"
                                   @change="toggleColumnSearchForm($event, data.item.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(label)="data">
                  {{ data.item.label }}
                </template>
              </b-table>
            </b-popover>
          </div>
          <div slot="content" id="searchOrderList">
            <div v-show="isShowSearch('init_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày khởi tạo</label>
              <date-picker v-model="filterData.init_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('confirmed_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày chốt đơn</label>
              <date-picker v-model="filterData.confirmed_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('data_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày phát sinh doanh số</label>
              <date-picker v-model="filterData.data_date" range valueType="format"></date-picker>
            </div>
            <div v-show="isShowSearch('charge_date')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngày tính phí</label>
              <date-picker v-model="filterData.charge_date" range valueType="format" type="month" lang="vi"></date-picker>
            </div>
            <div v-show="isShowSearch('pics')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nhân viên chăm sóc</label>
              <multiselect v-model="filterData.pics" id="ajax1" label="name" track-by="code"
                           placeholder="Nhập để tìm kiếm người dùng"
                           open-direction="bottom" :options="groupUser" :multiple="true" :searchable="true"
                           group-label="label" group-values="users" :group-select="true"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           :loading="loadingUser" :internal-search="true" :clear-on-select="true"
                           :close-on-select="false" :options-limit="300" :limit="numberOfUser" :max-height="600"
                           :disabled="disablePic"
                           :show-no-results="false" :hide-selected="false">
              </multiselect>
            </div>
            <div v-show="isShowSearch('products')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Sản phẩm</label>
              <multiselect id="ajax" v-model="filterData.products" :clear-on-select="false"
                           :close-on-select="false" :hide-selected="false" :internal-search="true" :limit="2"
                           :loading="loadingProduct" :max-height="600" :multiple="true"
                           :options="groupProduct" :options-limit="300" :searchable="true" :show-no-results="false"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="products" :group-select="true"
                           label="name" open-direction="bottom"
                           placeholder="Nhập để tìm kiếm sản phẩm" track-by="code">
              </multiselect>
            </div>
            <div v-show="isShowSearch('deleted_products')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Sản phẩm đã xóa</label>
              <multiselect id="ajax" v-model="filterData.deletedProducts" :clear-on-select="false"
                           :close-on-select="false" :hide-selected="false" :internal-search="true" :limit="2"
                           :loading="loadingDeletedProduct" :max-height="600" :multiple="true"
                           :options="deletedGroupProduct" :options-limit="300" :searchable="true" :show-no-results="false"
                           select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                           group-label="label" group-values="products" :group-select="true"
                           label="name" open-direction="bottom"
                           placeholder="Nhập để tìm kiếm sản phẩm" track-by="code">
              </multiselect>
            </div>

            <div v-show="isShowSearch('status')" class="form-group col-md-3 col-sm-6 col-xs-12" id="orderStatusSelect">
              <label>Trạng thái đơn hàng</label>
              <div class="d-flex">
                <multiselect v-model="filterData.status" :options="statusList" :multiple="true" :close-on-select="false"
                             :limit="1"
                             @select="onSelectStatus($event, filterData.status)"
                             @remove="onRemoveStatus($event, filterData.status)"
                             placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
                <multiselect v-model="filterData.statusDetail" :limit="1" :options="statusDetailList" :multiple="true"
                             :close-on-select="false" placeholder="Vui lòng chọn" label="text"
                             track-by="value"></multiselect>
              </div>
            </div>
            <div v-show="isShowSearch('data_source')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Nguồn đơn</label>
              <div class="d-flex">
                <multiselect v-model="filterData.data_source" :options="data_source" :multiple="true"
                             :close-on-select="false" :limit="1"
                             @select="onSelectSource($event, filterData.status)"
                             @remove="onRemoveSource($event, filterData.status)"
                             placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
                <multiselect v-model="filterData.data_channel" :options="data_channel" :multiple="true"
                             :close-on-select="false" :limit="1"
                             placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
              </div>
            </div>
<!--            <div v-show="isShowSearch('debt_status')" class="form-group col-md-3 col-sm-6 col-xs-12">-->
<!--              <label>Trạng thái nợ</label>-->
<!--              <multiselect v-model="filterData.debt_status" :options="debt_status_list" :multiple="false"-->
<!--                           :close-on-select="true"-->
<!--                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>-->
<!--            </div>-->

            <div v-show="isShowSearch('customer_name')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Tên khách hàng</label>
              <input type="text" class="form-control" v-model="filterData.customer_name" v-on:keyup.enter="search"
                     placeholder="Nhập tên khách hàng..."/>
            </div>
            <div v-show="isShowSearch('phone')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Số điện thoại</label>
              <input type="text" class="form-control" v-model="filterData.phone" v-on:keyup.enter="search"
                     placeholder="Nhập tên số điện thoại..."/>
            </div>
            <div v-show="isShowSearch('id')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Mã đơn hàng</label>
              <input type="number" class="form-control" v-model.number="filterData.id" v-on:keyup.enter="search"
                     placeholder="Nhập mã đơn hàng"/>
            </div>
            <div v-show="isShowSearch('order_types')" class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Loại sản phẩm</label>
              <multiselect v-model="filterData.order_types" :options="orderTypes" :multiple="true"
                           :close-on-select="false"
                           placeholder="Chọn loại sản phẩm" label="text" track-by="value"></multiselect>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center">
              <b-button variant="danger" @click="add" class="mr-2" :disabled="!isEditable"><span
                class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                Thêm mới
              </b-button>
              <b-button variant="warning" @click="bulkUpdate" class="mr-2" :disabled="!isEditable"><span
                class="fa fa-retweet" aria-hidden="true"></span>
                Cập nhật trạng thái
              </b-button>
              <b-button variant="secondary" @click="splitForSale" class="mr-2" :disabled="!isEditable || disablePic"><span
                class="glyphicon glyphicon-adjust" aria-hidden="true"></span>
                Chia cho sale
              </b-button>
              <b-button variant="primary" @click="printOrder" class="mr-2" :disabled="!isEditable"><span
                class="glyphicon glyphicon-adjust" aria-hidden="true"></span>
                In Đơn
              </b-button>
              <b-button variant="info" @click="exportOrders" class="mr-2"><span
                class="glyphicon glyphicon-export" aria-hidden="true"></span>
                Export
              </b-button>
              <b-button variant="success" @click="search" v-on:keyup.enter="search">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
              </b-button>
            </div>
          </div>
        </Box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <Box theme="box-primary" title="Danh sách đơn hàng">
          <div slot="custombtn">
            <button id="popover-config-table" class="btn btn-box-tool">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </button>
            <b-popover :show.sync="showConfigTable" target="popover-config-table" title="Cấu hình hiển thị"
                       triggers="hover">
              <b-table :items="configItems" responsive :fields="configFields">
                <template v-slot:cell(key)="data">
                  <b-form-checkbox v-model="data.item.show"
                                   @change="toggleColumn($event, data.item.key)"></b-form-checkbox>
                </template>
                <template v-slot:cell(label)="data">
                  {{ data.item.label }}
                </template>
              </b-table>
            </b-popover>
          </div>
          <div slot="content">
            <b-table bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty
                     :select-mode="'multi'"
                     ref="selectableTable"
                     @row-dblclicked="onDoubleClicked"
                     selectable
                     @row-selected="onRowSelected"
            >
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <!-- A custom formatted header cell for field 'name' -->
              <template #head(row_selected)="data">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="checkAll"
                  @change="onCheckAll"
                  name="checkbox-1"
                  value="check_all"
                  unchecked-value="uncheck_all"
                >
                </b-form-checkbox>
              </template>

              <template v-slot:cell(row_selected)="data">
                <div class="d-flex justify-content-center flex-column align-items-center">
                  <b-form-group>
                    <b-form-checkbox type="checkbox" v-model="data.rowSelected"
                                     @change="toggleRow(data)"></b-form-checkbox>
                  </b-form-group>
                </div>
              </template>
              <template v-slot:cell(id)="data">
                <div class="d-flex justify-content-center flex-column align-items-center">
                  <ColorTags v-if="data.item.id" :tags="generateOrderId(data.item)"></ColorTags>
                </div>
              </template>
              <template v-slot:cell(customer_name)="data">
                <i class="fa fa-user" aria-hidden="true"></i>
                <span>{{ data.item.customer_name }}</span>
                <br>
                <i class="fa fa-phone" aria-hidden="true"></i>
                <span class="tel" @click="callPhone(data.item.customer.phone)">{{ data.item.customer.phone }}</span>
              </template>
              <template v-slot:cell(debt)="data">
                {{ data.item.debt | format_currency }}
              </template>
              <template v-slot:cell(price)="data">
                {{ data.item.price | format_currency }}
              </template>
              <template v-slot:cell(annual_debt)="data">
                {{ data.item.annual_debt | format_currency }}
              </template>

              <template v-slot:cell(status)="data">
                <div class="d-flex justify-content-center flex-column align-items-center">
                  <ColorTags v-if="data.item.data_status" :tags="generateStatus(data.item)"></ColorTags>
                  <ColorTags v-if="data.item.data_sub_status" :tags="generateSubStatus(data.item)"></ColorTags>
                </div>
              </template>
              <template v-slot:cell(data_source)="data">
                <div class="d-flex justify-content-center flex-column align-items-center">
                  <ColorTags v-if="data.item.data_source" :tags="generateSource(data.item)"></ColorTags>
                  <ColorTags v-if="data.item.data_channel" :tags="generateChannel(data.item)"></ColorTags>
                </div>
              </template>

              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>

              <template v-slot:cell(stt)="data">
                {{ data.item.id }}
              </template>

              <template v-slot:cell(price)="data">
                {{ (data.item.amount + data.item.annual_amount) | format_currency }}
              </template>

              <template v-slot:cell(monthly_order_amount)="data">
                {{ data.item.monthly_order_amount | format_currency }}
              </template>

              <template v-slot:cell(care_notes)="data">
                <b-form-textarea
                  v-model="data.item.care_notes"
                  id="textarea-rows"
                  @keydown.enter.shift.exact.prevent="saveCareNote(data.item)"
                  @blur="saveCareNote(data.item)"
                  @dblclick="allowEditCareNote(data.item)"
                  :readonly="!editCareNotes.includes(data.item.id)"
                  :plaintext="!editCareNotes.includes(data.item.id)"
                  :style="data.item.care_notes !=='' ? 'height: 68px!important;' : ''"
                  :size="data.item.care_notes ==='' ? 'sm' : ''"
                ></b-form-textarea>
              </template>
              <template v-slot:cell(created_at)="data">
                {{ data.item.created_at | format_date_time }}
              </template>
              <template v-slot:cell(duplicated_with)="data">
                <div class="d-flex justify-content-center flex-column align-items-center">
                  <ColorTags v-if="data.item.duplicated_with" :tags="generateDuplicatedId(data.item)"></ColorTags>
                </div>
              </template>
            </b-table>
          </div>
          <div slot="footer">
            <div><strong>Tổng đơn hàng: </strong><label>{{ totalRow }}</label></div>
            <div><strong>Tổng doanh thu phân bổ: </strong><label>{{ totalMonthlyOrderAmount | format_currency }}</label></div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="page-size-container">
                <span>Hiển thị</span>
                <b-form-select
                  id="pageSize"
                  v-model="pageSize"
                  :options="pageSizes"
                  required
                ></b-form-select>
                <span>  dòng</span>
              </div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="pageSize"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </Box>

        <b-modal size='xl' id="bulkUpdateModal" hide-footer title="Cập nhật trạng thái hàng loạt">
          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <label>Trạng thái đơn hàng</label>
            <div class="d-flex">
              <multiselect v-model="bulkUpdateData.status" :options="statusList" :multiple="false"
                           :close-on-select="true" :limit="1"
                           @select="onSelectStatusBulkUpdateData($event, bulkUpdateData.status)"
                           @remove="onRemoveStatusBulkUpdateData($event, filterData.status)"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
              <multiselect v-model="bulkUpdateData.statusDetail" :limit="1" :options="statusDetailList"
                           :multiple="false"
                           :close-on-select="true" placeholder="Vui lòng chọn" label="text"
                           track-by="value"></multiselect>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="pull-right mt-3">
              <b-button variant="success" class="w-150px" @click="saveBulkUpdate" :disabled="!isEditable">Lưu</b-button>
            </div>
          </div>
        </b-modal>

        <b-modal size='xl' id="splitForSaleModal" hide-footer title="Chia cho sale">
          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <label>Nhân viên chăm sóc</label>
            <multiselect v-model="saleData.pics" id="ajax2" label="name" track-by="code"
                         placeholder="Nhập để tìm kiếm người dùng"
                         open-direction="bottom" :options="users" :multiple="true" :searchable="true"
                         :loading="loadingUser" :internal-search="false" :clear-on-select="false"
                         :close-on-select="false" :options-limit="300" :limit="3" :max-height="600"
                         :show-no-results="false" :hide-selected="false" @search-change="debounceUser">
            </multiselect>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="pull-right mt-3">
              <b-button variant="success" class="w-150px" @click="saveSplitForSale" :disabled="!isEditable">Chia số
              </b-button>
            </div>
          </div>
        </b-modal>

        <b-modal size='xl' id="orderDetailModal" hide-footer title="Chi tiết đơn hàng" @hide="() => this.filter()"
                 header-class="crm-modal">
          <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
            <OrderAdd :disablePic="disablePic" :orderId="selectedId" :hide-modal="hideModal"></OrderAdd>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <OrderDetailList :updatingOrderId="selectedId" type="NEW_BUY"></OrderDetailList>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <OrderDetailList :updatingOrderId="selectedId" type="ANNUAL_BUY"></OrderDetailList>
          </div>
        </b-modal>
      </div>

      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        filename="crm_file_print"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a5"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        @progress="onProgress($event)"
        :paginate-elements-by-height="800"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <OrderPrint :orders="selected"/>
        </section>
      </vue-html2pdf>
    </section>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {debounce, isNumber} from 'lodash'
import UserApi from '../../api/user'
import Utils from '../../common/utils'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import {mapActions, mapGetters} from 'vuex'
import Box from '../../components/Box'
import OrderAPI from '../../api/orderApi'
import DataStatusAPI from '../../api/dataStatus'
import DataSubStatusAPI from '../../api/dataSubStatus'
import DataSourceAPI from '../../api/dataSource'
import DataChannelAPI from '../../api/dataChannel'
import {
  DEBT_STATUS_LIST,
  LOCAL_STORAGE_KEY,
  PERMISSION_KEY,
  MAX_SALE_USER_NUMBER,
  MAX_PRODUCT_NUMBER
} from '../../common/constant'
import OrderAdd from './OrderAddOrEdit'
import OrderDetailList from './OrderDetailList'
import OrderGeneral from './OrderGeneral'
import OrderCallHistory from './OrderCallHistory'
import ChatBox from './ChatBox'
import ColorTags from '../../components/ColorTags'
import Tags from '../../components/Tags'
import OrderPrint from '../../components/OrderPrint'
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'
import ProductApi from '../../api/product'

export default {
  name: 'OrderList',
  components: {
    Box,
    DatePicker,
    Multiselect,
    OrderAdd,
    OrderDetailList,
    OrderGeneral,
    OrderCallHistory,
    ChatBox,
    ColorTags,
    Tags,
    OrderPrint,
    VueHtml2pdf
  },
  data () {
    return {
      company: null,
      checkAll: false,
      filterData: {
        init_date: [moment().subtract(3, 'day').format('yyyy-MM-DD'), moment().format('yyyy-MM-DD')],
        confirmed_date: [null, null],
        data_date: [null, null],
        status: [],
        statusDetail: [],
        data_source: [],
        data_channel: [],
        phone: '',
        customer_name: '',
        debt_status: null,
        pics: [],
        order_types: [],
        id: null,
        charge_date: [null, null],
        products: [],
        deletedProducts: []
      },
      bulkUpdateData: {
        status: [],
        statusDetail: [],
      },
      saleData: {
        pics: []
      },
      statusList: [],
      statusDetailList: [],
      data_source: [],
      data_channel: [],
      debt_status_list: DEBT_STATUS_LIST,
      loading: false,
      products: [],
      groupProduct: [],
      deletedProducts: [],
      deletedGroupProduct: [],
      loadingProduct: false,
      loadingDeletedProduct: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      totalMonthlyOrderAmount: 0,
      pageSizes: [
        {text: 1000, value: 1000},
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      fields: [],
      originFields: [
        {
          key: 'row_selected',
          label: 'Chọn',
          thClass: 'text-center',
          show: true
        }, {
          key: 'id',
          label: 'Mã đơn hàng',
          show: true
        }, {
          key: 'customer_name',
          label: 'Thông tin khách hàng',
          show: true
        }, {
          key: 'care_notes',
          label: 'Lịch sử chăm sóc',
          thStyle: 'width: 250px',
          show: true
        }, {
          key: 'price',
          label: 'Giá tiền hợp đồng',
          show: true
        }, {
          key: 'confirmed_date',
          label: 'Ngày xác nhận đơn hàng',
          show: true
        }, {
          key: 'debt',
          label: 'Công nợ mua mới',
          show: true
        }, {
          key: 'due_date',
          label: 'Ngày cần thanh toán công nợ',
          show: true
        }, {
          key: 'annual_debt',
          label: 'Công nợ định kỳ',
          show: true
        }, {
          key: 'annual_due_date',
          label: 'Ngày thanh toán công nợ định kỳ',
          show: true
        }, {
          key: 'pic_name',
          label: 'Nhân viên chăm sóc',
          show: true
        }, {
          key: 'status',
          label: 'Trạng thái đơn hàng',
          show: true
        }, {
          key: 'data_source',
          label: 'Nguồn data',
          show: true
        }, {
          key: 'monthly_order_amount',
          label: 'Doanh thu phân bổ',
          show: true
        }, {
          key: 'duplicated_with',
          label: 'Trùng đơn',
          show: true
        }, {
          key: 'created_at',
          label: 'Thời gian data vào hệ thống',
          show: true
        }, {
          key: 'created_by',
          label: 'Người tạo',
          show: true
        }
      ],
      configItems: [
        {
          key: 'id',
          label: 'Mã đơn hàng',
          show: true
        }, {
          key: 'phone_number',
          label: 'SĐT/Mã KH',
          show: true
        }, {
          key: 'customer_name',
          label: 'Thông tin khách hàng',
          show: true
        }, {
          key: 'care_notes',
          label: 'Lịch sử chăm sóc',
          thStyle: 'width: 250px',
          show: true
        }, {
          key: 'price',
          label: 'Giá tiền hợp đồng',
          show: true
        }, {
          key: 'debt',
          label: 'Công nợ',
          show: true
        }, {
          key: 'due_date',
          label: 'Ngày cần thanh toán công nợ',
          show: true
        }, {
          key: 'annual_debt',
          label: 'Công nợ định kỳ',
          show: true
        }, {
          key: 'confirmed_date',
          label: 'Ngày xác nhận đơn hàng',
          show: true
        }, {
          key: 'annual_due_date',
          label: 'Ngày thanh toán công nợ định kỳ',
          show: true
        }, {
          key: 'pic_name',
          label: 'Nhân viên chăm sóc',
          show: true
        }, {
          key: 'status',
          label: 'Trạng thái đơn hàng',
          show: true
        }, {
          key: 'data_source',
          label: 'Nguồn data',
          show: true,
          thStyle: 'width: 150px',
        }, {
          key: 'monthly_order_amount',
          label: 'Doanh thu phân bổ',
          show: true
        }, {
          key: 'duplicated_with',
          label: 'Trùng đơn',
          show: true
        }, {
          key: 'created_at',
          label: 'Thời gian data vào hệ thống',
          show: true
        }, {
          key: 'created_by',
          label: 'Người tạo',
          show: true
        }
      ],
      configFields: [
        {
          key: 'key',
          label: 'Hiển thị'
        }, {
          key: 'label',
          label: 'Cột'
        }
      ],
      isEditCareNote: false,
      editCareNotes: [],
      configSearchItems: [
        {
          key: 'init_date',
          label: 'Ngày khởi tạo',
          show: true
        }, {
          key: 'confirmed_date',
          label: 'Ngày chốt đơn',
          show: true
        }, {
          key: 'data_date',
          label: 'Ngày phát sinh doanh số',
          show: true
        }, {
          key: 'status',
          label: 'Trạng thái',
          show: true
        }, {
          key: 'data_source',
          label: 'Nguồn data',
          show: false
        }, {
          key: 'phone',
          label: 'Số điện thoại',
          show: false
        }, {
          key: 'customer_name',
          label: 'Tên khách hàng',
          show: false
        }, {
          key: 'pics',
          label: 'Nhân viên chăm sóc',
          show: false
        }, {
          key: 'id',
          label: 'Mã đơn hàng',
          show: false
        }, {
          key: 'order_types',
          label: 'Loại sản phẩm',
          show: false
        }, {
          key: 'charge_date',
          label: 'Ngày tính phí',
          show: false
        }, {
          key: 'products',
          label: 'Sản phẩm',
          show: false
        }, {
          key: 'deleted_products',
          label: 'Sản phẩm đã xóa',
          show: false
        }
      ],
      items: [],
      users: [],
      groupUser: [],
      orderTypes: [{'text': 'Sản phẩm mua 1 lần', 'value': 'NEW_BUY'}, {'text': 'Sản phẩm định kì', 'value': 'ANNUAL_BUY'}],
      loadingUser: false,
      debounceUser: null,
      selected: [],
      showConfigTable: false,
      showConfigSearch: false,
      isEditable: true,
      disablePic: false,
      selectedId: null,
      numberOfUser: 2,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission',
      'currentUser',
      'softphone'
    ])
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    if (this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE)) {
      this.disablePic = true
      this.filterData.pics = [{code: this.userInfo.id, name: this.userInfo.username}]
    }
    this.initDataStatus()
    this.filterProduct()
    this.filterDeletedProduct()
    this.filterUser('')
    this.isEditable = this.hasEditPermission()
    const orderListSearchItems = localStorage.getItem(LOCAL_STORAGE_KEY.ORDER_LIST_SEARCH_ITEMS)
    if (orderListSearchItems) {
      this.configSearchItems = JSON.parse(orderListSearchItems)
    }
    if (localStorage.getItem(LOCAL_STORAGE_KEY.ORDER_LIST_FROM_DATE)) {
      this.filterData.from_date = localStorage.getItem(LOCAL_STORAGE_KEY.ORDER_LIST_FROM_DATE)
    }
    if (localStorage.getItem(LOCAL_STORAGE_KEY.ORDER_LIST_TO_DATE)) {
      this.filterData.to_date = localStorage.getItem(LOCAL_STORAGE_KEY.ORDER_LIST_TO_DATE)
    }
  },
  created () {
    this.debounceUser = debounce(this.filterUser.bind(this), 500)
    this.fields = this.originFields
    window.addEventListener('resize', this.onResizeScreen)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResizeScreen)
  },
  methods: {
    ...mapActions([
      'changePhoneNumber',
      'openSoftphone'
    ]),
    onResizeScreen () {
      if (window.innerWidth < 1550) {
        this.numberOfUser = 1
      } else {
        this.numberOfUser = 2
      }
    },
    callPhone (phoneNumber) {
      this.changePhoneNumber({phoneNumber: phoneNumber})
      if (!this.currentUser.user_info.call_center || !this.currentUser.user_info.call_center.ext) {
        this.$bvModal.msgBoxOk('Bạn chưa được cấp phép gọi điện hoặc công ty chưa đăng ký dịch vụ gọi điện ITY', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
        }).then(res => {
        })
      } else {
        this.openSoftphone({status: true})
        this.$bvModal.show('phone-call-modal')
      }
    },
    isShowSearch (key) {
      const item = this.configSearchItems.find(item => item.key === key)
      if (item) {
        return item.show
      }
      return false
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE)
    },
    filterDeletedProduct () {
      this.loadingDeletedProduct = true
      ProductApi.filter({
        name: '',
        company_id: this.company.id,
        product_delete_type: 'DELETED'
      }, 0, MAX_PRODUCT_NUMBER).then(res => {
        this.deletedProducts = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        // this.filterData.products = this.products
        this.deletedGroupProduct = [
          {
            label: 'Tất cả',
            products: this.deletedProducts
          }
        ]
        this.filterUser('')
        this.loadingDeletedProduct = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingDeletedProduct = false
      })
    },
    filterProduct () {
      this.loadingProduct = true
      ProductApi.filter({
        name: '',
        company_id: this.company.id,
        product_delete_type: 'ACTIVE'
      }, 0, MAX_PRODUCT_NUMBER).then(res => {
        this.products = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        // this.filterData.products = this.products
        this.groupProduct = [
          {
            label: 'Tất cả',
            products: this.products
          }
        ]
        this.filterUser('')
        this.loadingProduct = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingProduct = false
      })
    },
    initDataStatus () {
      Promise.all([this.getDataStatus(), this.getDataSubStatus(), this.getDataSource(), this.getDataChannel()]).then(([dataStatus, dataSubStatus, dataSource, dataChannel]) => {
        this.statusList = dataStatus.map(item => {
          const subStatus = dataSubStatus.filter(subItem => subItem.data_status === item.id).map(subItem => {
            return {value: subItem.id, text: subItem.name, data_status: subItem.data_status}
          })
          return {value: item.id, text: item.name, details: subStatus}
        })

        this.data_source = dataSource.map(item => {
          const subList = dataChannel.filter(subItem => subItem.data_source === item.id).map(subItem => {
            return {value: subItem.id, text: subItem.name, data_source: subItem.data_source}
          })
          return {value: item.id, text: item.name, details: subList}
        })
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    async getDataStatus () {
      const response = await DataStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSubStatus () {
      const response = await DataSubStatusAPI.filter(null, 0, 100)
      return response.data.data.records
    },
    async getDataSource () {
      const response = await DataSourceAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    async getDataChannel () {
      const response = await DataChannelAPI.filter({name: null}, 0, 100)
      return response.data.data.records
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findSaleByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })

        this.users.unshift({
          'name': 'Chưa chia data',
          'code': null
        })

        if (!this.disablePic) {
          this.filterData.pics = this.users
        }

        this.groupUser = [
          {
            label: 'Tất cả',
            users: this.users
          }
        ]
        this.loadingUser = false
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      OrderAPI.filter(this.buildFilterData(), this.currentPage - 1, this.pageSize, 'monthly_order_amount').then(res => {
        this.loading = false
        this.items = res.data.data.records.map(item => {
          if (item.duplicated_with !== null) {
            return {...item, _cellVariants: {id: 'duplicated'}}
          }

          return item
        })
        this.totalRow = res.data.data.total
        this.totalMonthlyOrderAmount = res.data.data.sum_value
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    buildFilterData () {
      const filter = {
        from_date: this.filterData.init_date[0],
        to_date: this.filterData.init_date[1],
        confirmed_from_date: this.filterData.confirmed_date[0],
        confirmed_to_date: this.filterData.confirmed_date[1],
        payment_from_date: this.filterData.data_date[0],
        payment_to_date: this.filterData.data_date[1],
        charge_from_date: this.filterData.charge_date[0] ? this.filterData.charge_date[0] + '-01' : this.filterData.charge_date[0],
        charge_to_date: this.filterData.charge_date[1] ? this.filterData.charge_date[1] + '-01' : this.filterData.charge_date[1],
        data_status: [],
        data_source: [],
        phone: this.filterData.phone,
        customer_name: this.filterData.customer_name,
        debt_status: null,
        pics: [],
        id: null,
        order_types: [],
        product_id_list: []
      }
      if (this.filterData.statusDetail.length === 0) {
        filter.data_status = this.filterData.status.map(item => {
          return {data_status_id: item.value, data_sub_status_id: null}
        })
      } else {
        filter.data_status = this.filterData.statusDetail.map(item => {
          return {data_status_id: item.data_status, data_sub_status_id: item.value}
        })
      }
      if (this.filterData.data_channel.length === 0) {
        filter.data_source = this.filterData.data_source.map(item => {
          return {data_source_id: item.value, data_channel_id: null}
        })
      } else {
        filter.data_source = this.filterData.data_channel.map(item => {
          return {data_source_id: item.data_source, data_channel_id: item.value}
        })
      }

      if (this.filterData.order_types.length !== 0) {
        filter.order_types = this.filterData.order_types.map(item => item.value)
      }

      filter.pics = this.filterData.pics.map(item => item.code)

      if (this.filterData.id && isNumber(parseInt(this.filterData.id))) {
        filter.id = this.filterData.id
        filter.pics = this.users.map(item => item.code)
      }

      // if (this.filterData.debt_status) {
      //   filter.debt_status = this.filterData.debt_status.value
      // }
      if (filter.phone === '' || filter.phone === null) {
        delete filter['phone']
      }
      if (filter.customer_name === '' || filter.customer_name === null) {
        delete filter['customer_name']
      }
      if (filter.debt_status === '' || filter.debt_status === null) {
        delete filter['debt_status']
      }
      if (this.filterData.products.length > 0) {
        filter.product_id_list = this.filterData.products.map(item => item.code)
      }
      if (this.filterData.deletedProducts.length > 0) {
        filter.product_id_list.push(...this.filterData.deletedProducts.map(item => item.code))
      }
      if (filter.product_id_list.length === 0) {
        filter.product_id_list = [0]
      }

      return filter
    },
    search () {
      this.filter()
    },
    add () {
      this.selectedId = null
      this.$bvModal.show('orderDetailModal')
    },
    hideModal (modalId) {
      this.$bvModal.hide(modalId)
    },
    detail (id) {
      this.selectedId = id
      this.$bvModal.show('orderDetailModal')
    },
    onSelectStatus (event, status) {
      this.statusDetailList = []
      if (this.filterData.status.length === 0) {
        this.statusDetailList.push(...event.details)
      }
    },
    onRemoveStatus (event, status) {
      this.statusDetailList = []
      if (this.filterData.status.length === 2) {
        const lastStatus = this.filterData.status.filter(item => item.value !== event.value)
        this.statusDetailList.push(...lastStatus[0].details)
      }
    },
    onSelectStatusBulkUpdateData (event, status) {
      this.statusDetailList.push(...event.details)
      this.bulkUpdateData.statusDetail = null
    },
    onRemoveStatusBulkUpdateData (event, status) {
      this.statusDetailList = this.statusDetailList.filter(item => item.data_status !== event.value)
      this.bulkUpdateData.statusDetail = null
    },
    onSelectSource (event, source) {
      this.data_channel = []
      if (this.filterData.data_source.length === 0) {
        this.data_channel.push(...event.details)
      }
    },
    onRemoveSource (event, source) {
      this.data_channel = []
      if (this.filterData.data_source.length === 2) {
        const lastItems = this.filterData.data_source.filter(item => item.value !== event.value)
        this.data_channel.push(...lastItems[0].details)
      }
    },
    check (event, id) {
      if (event) {
        this.selectedIds.push(id)
      } else {
        this.selectedIds = this.selectedIds.filter(item => item !== id)
      }
    },
    toggleColumn (event, key) {
      this.originFields = this.originFields.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)
    },
    onRowSelected (items) {
      this.selected = items
    },
    onDoubleClicked (item) {
      this.detail(item.id)
    },
    onCheckAll (event) {
      if (this.checkAll === 'check_all') {
        this.$refs.selectableTable.selectAllRows()
      } else {
        this.$refs.selectableTable.clearSelected()
      }
    },
    bulkUpdate () {
      if (this.selected.length > 0) {
        this.$bvModal.show('bulkUpdateModal')
      }
    },
    splitForSale () {
      if (this.selected.length > 0) {
        this.$bvModal.show('splitForSaleModal')
      }
    },
    exportOrders () {
      if (this.loading) {
        return
      }
      this.loading = true
      OrderAPI.export(this.buildFilterData()).then(res => {
        this.loading = false
        let filename = res.data.data.file
        window.location.href = 'https://crm.ity.vn' + filename
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    printOrder () {
      if (this.selected.length > 0) {
        this.$refs.html2Pdf.generatePdf()
      }
    },
    onProgress (event) {
      console.log(`Processed: ${event} / 100`)
    },
    saveBulkUpdate () {
      const order_id_list = this.selected.map(item => item.id)
      const data_status_id = this.bulkUpdateData.status.value
      const data_sub_status_id = this.bulkUpdateData.statusDetail.value
      if (this.loading) {
        return
      }
      this.loading = true
      OrderAPI.bulkUpdateOrderStatus({order_id_list, data_status_id, data_sub_status_id}).then(res => {
        this.loading = false
        this.$bvModal.hide('bulkUpdateModal')
        Utils.successToast(this.$bvToast)
        this.filter()
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    saveSplitForSale () {
      const order_id_list = this.selected.map(item => item.id)
      const pic_list = this.saleData.pics.map(item => item.code)
      if (this.loading) {
        return
      }
      this.loading = true
      OrderAPI.bulkUpdateOrderPic({order_id_list, pic_list}).then(res => {
        this.loading = false
        this.$bvModal.hide('splitForSaleModal')
        Utils.successToast(this.$bvToast)
        this.filter()
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    remove (id) {
      if (id) {
        this.$bvModal.msgBoxConfirm('Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            OrderAPI.remove(id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
    toggleColumnSearchForm (event, key) {
      this.configSearchItems = this.configSearchItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      localStorage.setItem(LOCAL_STORAGE_KEY.ORDER_LIST_SEARCH_ITEMS, JSON.stringify(this.configSearchItems))
    },
    toggleRow (row) {
      if (row.rowSelected) {
        this.$refs.selectableTable.selectRow(row.index)
      } else {
        this.$refs.selectableTable.unselectRow(row.index)
      }
    },
    generateStatus (selectedRow) {
      const text = selectedRow.data_status.name
      const color = selectedRow.data_status.color
      return [{text: text, color: color}]
    },
    generateOrderId (selectedRow) {
      const text = selectedRow.id
      const color = '#a3ce71'
      return [{text: text, color: color}]
    },
    generateDuplicatedId (selectedRow) {
      const text = selectedRow.duplicated_with
      const color = '#a3ce71'
      return [{text: text, color: color}]
    },
    generateSubStatus (selectedRow) {
      const text = selectedRow.data_sub_status.name
      const color = selectedRow.data_sub_status.color
      return [{text: text, color: color}]
    },
    generateSource (selectedRow) {
      if (selectedRow.data_channel === null) {
        return [{text: selectedRow.data_source.name, color: '#f5c33b'}]
      }
      return [{text: selectedRow.data_source.name, color: '#f5c33b'}]
    },
    generateChannel (selectedRow) {
      if (selectedRow.data_channel === null) {
        return [{text: selectedRow.data_source.name, color: '#f5c33b'}]
      }
      return [{text: selectedRow.data_channel.name, color: '#f5c33b'}]
    },
    cancelEditCareNote (data) {
      this.isEditCareNote = false
      this.editCareNotes = []
    },
    saveCareNote (data) {
      this.isEditCareNote = false
      this.editCareNotes = []
      OrderAPI.update(data).then(res => {
        if (res != null && res.data != null) {
          Utils.successToast(this.$bvToast)
        }
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    allowEditCareNote (data) {
      this.isEditCareNote = true
      this.editCareNotes.push(data.id)
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderList.vue